import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmDialogV2Data {
    title?: string;
    body?: string;
    buttons: {
        confirm?: {
            text: string;
            class: string;
        };
        cancel?: {
            text: string;
            class: string;
        };
    };
}

@Component({
    selector: 'confirm-dialog-v2',
    templateUrl: './confirm-dialog-v2.component.html',
    styleUrls: ['./confirm-dialog-v2.component.scss'],
})
export class ConfirmDialogV2Component {
    public buttonClick = false;

    public loading = false;

    @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogV2Component>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogV2Data,
    ) {}

    get title(): string {
        return this.data.title;
    }

    get body(): string {
        return this.data.body;
    }

    get cancelButton(): { text: string; class: string } {
        return this.data?.buttons?.cancel;
    }

    get confirmButton(): { text: string; class: string } {
        return this.data?.buttons?.confirm;
    }

    onNoClick(): void {
        this.cancel();
    }

    confirm(): void {
        this.onSubmit.emit(true);
    }

    cancel(): void {
        this.onSubmit.emit(false);
    }
}
